import { useMutation } from "react-query";
import {
  ClosedVehiclePremiumRequestParams,
  adjustVehiclePremium,
} from "store/api/api";
import { handleAxiosError } from "store/util";
import { MUTATION_KEYS } from "../queryKeys";

const adjustVehiclePremiumFn = async ({
  rowVersion,
  params,
}: {
  rowVersion: string;
  params: ClosedVehiclePremiumRequestParams;
}) => {
  return await adjustVehiclePremium(rowVersion, params);
};

export function useAdjustVehiclePremium() {
  return useMutation(adjustVehiclePremiumFn, {
    mutationKey: MUTATION_KEYS.adjustVehiclePremium,
    onError: (err) => {
      handleAxiosError(err);
    },
  });
}
